import CoachAssistant from './CoachAssistant';

function App() {
  return <CoachAssistant />;
}

export default App;